<template>
    <div class="main box">
        <h1>No access</h1>
        <p>Your account is not linked to any menu yet.<br />Please ask an administrator to give you a role.</p>
    </div>
</template>

<script>
export default {
    name : "NoAccess"
}
</script>

<style lang="scss" scoped>
  h1 {
    color:#fff;
    text-align: center;
    font-size:25px;
    text-transform: uppercase;
    font-weight: 300;
    margin:40px auto;
  }

  p {
    color:#fff;
    text-align: center;
    line-height: 1.5em;
  }
</style>
